import React from 'react';
import { Field, useFormikContext } from 'formik';

import {
  AddButtonUi,
  AutoCompleteSelectUI,
  DatePickerUI,
  FormErrorUI,
  FormLabelUI,
  InputUI,
  TimePickerUi,
} from '../Interface';

const FormFields = ({ autocompleteOptions, autocompleteData, setProjectAddDialogOpen }) => {
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  return (
    <div className="grid grid-cols-6 gap-x-4 gap-y-2 mb-5">
      <div className="col-span-6">
        <Field
          name="simpleTaskName"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Megnevezés" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.simpleTaskName} />}
          InputLabelProps={{ shrink: values.simpleTaskName && values.simpleTaskName !== '' }}
        />
      </div>
      <div className="col-span-6 md:col-span-3">
        <div className="flex items-center">
          <Field
            type="autocomplete"
            name="projectId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Projekt" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.projectId} />}
            onChange={(_e, newVal) => {
              const findedProject = autocompleteData?.project.find((item) => item.projectId === newVal?.value);

              if (findedProject) {
                setFieldValue('companyId', findedProject.companyId ?? null);
              } else {
                setFieldValue('companyId', null);
              }
              setFieldValue('projectId', newVal?.value ?? null).then(() => {
                validateField('projectId');
              });
            }}
            InputLabelProps={{ shrink: values.projectId !== '' }}
            selectedValue={values.projectId}
            dataset={autocompleteOptions.project}
          />
          <AddButtonUi onClick={() => setProjectAddDialogOpen(true)} />
        </div>
      </div>
      <div className="col-span-6 md:col-span-3">
        <Field
          type="autocomplete"
          name="companyId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Cég" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.companyId} />}
          onChange={(_e, newVal) => {
            setFieldValue('companyId', newVal?.value ?? null).then(() => {
              validateField('companyId');
            });
          }}
          InputLabelProps={{ shrink: values.companyId !== '' }}
          selectedValue={values.companyId}
          dataset={autocompleteOptions.company}
        />
      </div>
      <div className="col-span-6 md:col-span-2">
        <Field
          type="autocomplete"
          name="simpleTaskTypeId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Típus" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.simpleTaskTypeId} />}
          onChange={(_e, newVal) => {
            setFieldValue('simpleTaskTypeId', newVal?.value ?? null).then(() => {
              validateField('simpleTaskTypeId');
            });
          }}
          InputLabelProps={{ shrink: values.simpleTaskTypeId !== '' }}
          selectedValue={values.simpleTaskTypeId}
          dataset={autocompleteOptions.type}
        />
      </div>
      <div className="col-span-6 md:col-span-2">
        <Field
          type="autocomplete"
          name="statusId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Státusz" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.statusId} />}
          onChange={(_e, newVal) => {
            setFieldValue('statusId', newVal?.value ?? null).then(() => {
              validateField('statusId');
            });
          }}
          InputLabelProps={{ shrink: values.statusId !== '' }}
          selectedValue={values.statusId}
          dataset={autocompleteOptions.status}
        />
      </div>
      <div className="col-span-6 md:col-span-2">
        <Field
          type="autocomplete"
          name="resposiblePersonId"
          component={AutoCompleteSelectUI}
          fullWidth
          label={<FormLabelUI text="Felelős" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.resposiblePersonId} />}
          onChange={(_e, newVal) => {
            setFieldValue('resposiblePersonId', newVal?.value ?? null).then(() => {
              validateField('resposiblePersonId');
            });
          }}
          InputLabelProps={{ shrink: values.resposiblePersonId !== '' }}
          selectedValue={values.resposiblePersonId}
          dataset={autocompleteOptions.user}
        />
      </div>
      <div className="col-span-6 md:col-span-2">
        <Field
          type="date"
          name="startDate"
          component={DatePickerUI}
          value={values.startDate}
          fullWidth
          label={<FormLabelUI text="Kezdő dátum" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.startDate} />}
          onChange={(date) => {
            setFieldValue('startDate', date).then(() => {
              validateField('startDate');
            });
          }}
          InputLabelProps={{ shrink: values.startDate !== '' }}
        />
      </div>
      <div className="col-span-6 md:col-span-2">
        <Field
          type="date"
          name="endDate"
          component={DatePickerUI}
          value={values.endDate}
          fullWidth
          label={<FormLabelUI text="Határidő" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.endDate} />}
          onChange={(date) => {
            setFieldValue('endDate', date).then(() => {
              validateField('endDate');
            });
          }}
          InputLabelProps={{ shrink: values.endDate !== '' }}
        />
      </div>
    </div>
  );
};

export default FormFields;
